import React from "react";

const Logo = ({src}) => {
    return <img className="logo" src={src || "/eizba/logo_pl.png"} alt=""/>;
};

export default Logo;
